import {createBrowserHistory} from 'history'
import { Modal } from 'antd'

const history = createBrowserHistory({
  getUserConfirmation(message, callback) {
    Modal.info({
      content: message,
      width: 500,
      onOk: () => callback(false),
      cancelButtonProps: { style: { display: "none" } }
    })
  }
})

export default history
